import React from "react";
import "./AboutUsDegerler.css";

import icon1 from "../../../assets/images/degerler_icon1.png";
import icon2 from "../../../assets/images/degerler_icon2.png";
import icon3 from "../../../assets/images/degerler_icon3.png";
import icon4 from "../../../assets/images/degerler_icon4.png";
import icon5 from "../../../assets/images/degerler_icon5.png";

const texts = [
  {
    icon: icon1,
    title: "1. Erişilebilirlik:",
    content:
      "Dil, yaş, sosyoekonomik düzey fark etmeksizin herkesin desteğe ulaşabilmesini sağlamak önceliğimizdir.",
  },
  {
    icon: icon2,
    title: "2. Bilimsellik:",
    content:
      "Tüm ürün ve süreçlerimizi bilimsel çalışmalara dayalı yaklaşımlarla geliştirir, literatüre katkı sağlarız.",
  },
  {
    icon: icon3,
    title: "3. Teknolojik Etki:",
    content:
      "Yapay zekâyı etik, sorumlu ve insan odaklı biçimde kullanırız. Teknoloji bizim için bir hedef değil, faydaya giden bir araçtır.",
  },
  {
    icon: icon4,
    title: "4. Güven & Saygı:",
    content:
      "Kullanıcılarımızın ve uzmanların verilerine, ihtiyaçlarına ve yolculuklarına saygı duyar, her adımı şeffaflıkla atarız.",
  },
  {
    icon: icon5,
    title: "5. Sosyal Fayda:",
    content:
      "Yenilik içinde anlamı önemseriz. Sunduğumuz çözümler en başta toplumsal fayda üretme sorumluluğu taşır.",
  },
];

const AboutUsDegerler = () => {
  return (
    <div className="degerler-wrapper">
      <div className="degerler-container">
        <p className="baslik">Değerlerimiz</p>
        <div className="degerler-listesi">
          {texts.map((item, index) => (
            <div className="deger-item" key={index}>
              <img src={item.icon} alt={item.title} className="deger-icon" />
              <div className="deger-text">
                <p className="text-baslik">{item.title}</p>
                <p className="text-metin">{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

  );
};

export default AboutUsDegerler;
